import { Amplify } from 'aws-amplify';

export const configureAmplify = () => {
  // Debug: Log environment variables
  console.log('🔍 Environment Variables Check:', {
    REACT_APP_GRAPHQL_ENDPOINT: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    REACT_APP_AWS_REGION: process.env.REACT_APP_AWS_REGION,
    REACT_APP_USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    REACT_APP_USER_POOL_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
    REACT_APP_IDENTITY_POOL_ID: process.env.REACT_APP_IDENTITY_POOL_ID,
  });

  // AWS Amplify v5 configuration format
  const amplifyConfig = {
    Auth: {
      region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      userPoolId: process.env.REACT_APP_USER_POOL_ID || '',
      userPoolWebClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
      identityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID || '',
      authenticationFlowType: 'USER_SRP_AUTH',
      signUpVerificationMethod: 'code',
      // OAuth configuration (kept for reference but we handle OAuth flow manually)
      // The identity_provider param in authorize URL skips Cognito Hosted UI
      // oauth: { ... } - intentionally removed to prevent Amplify from intercepting callbacks
    },
    aws_appsync_graphqlEndpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT || '',
    aws_appsync_region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
    Storage: {
      S3: {
        bucket: process.env.REACT_APP_MEDIA_BUCKET || '',
        region: process.env.REACT_APP_AWS_REGION || 'us-east-1',
      },
    },
  };

  // Validate required configuration
  if (!amplifyConfig.Auth.userPoolId) {
    throw new Error('REACT_APP_USER_POOL_ID is required');
  }

  if (!amplifyConfig.Auth.userPoolWebClientId) {
    throw new Error('REACT_APP_USER_POOL_CLIENT_ID is required');
  }

  if (!amplifyConfig.Auth.identityPoolId) {
    throw new Error('REACT_APP_IDENTITY_POOL_ID is required');
  }

  if (!amplifyConfig.aws_appsync_graphqlEndpoint) {
    throw new Error('REACT_APP_GRAPHQL_ENDPOINT is required');
  }

  Amplify.configure(amplifyConfig);

  console.log('✅ AWS Amplify v5 configured successfully');
  console.log('🔧 Configuration:', amplifyConfig);
};
